module.exports = __webpack_public_path__ + "img/88.b3ec970.png";